/* BlissPark v2 global behaviour: modals, one-time reveal. */
(function () {
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-bp-modal-open]');
    if (o) { var m = document.getElementById(o.getAttribute('data-bp-modal-open')); if (m) { m.classList.add('is-open'); m.__opener = o; var x = m.querySelector('.bp-modal__x'); if (x) x.focus(); } return; }
    var c = e.target.closest && e.target.closest('[data-bp-modal-close]');
    if (c) { var mm = c.closest('.bp-modal'); if (mm) { mm.classList.remove('is-open'); if (mm.__opener) mm.__opener.focus(); } }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.bp-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -40px 0px' });
    var arm = function () { document.querySelectorAll('.bp-reveal:not(.is-in)').forEach(function (el) { io.observe(el); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
    document.addEventListener('shopify:section:load', arm);
  } else {
    document.querySelectorAll('.bp-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }
})();
